<script>
import {Tooltip} from "bootstrap";
import '@fortawesome/fontawesome-free/css/all.min.css';

export default {
  props: {
    text: {
      type: String,
      default: "IS NOT IMPLEMENTED",
    }
  },
  mounted() {
    this.tooltip = new Tooltip(this.$refs.trigger)
  },
  beforeUnmount() {
    if (this.tooltip) this.tooltip.dispose()
  }
}
</script>

<template>
  <button
      ref="trigger"
      type="button"
      class="hint-trigger fas fa-info-circle"
      data-bs-toggle="tooltip"
      data-bs-placement="right"
      :title="text"
      :aria-label="`More information: ${text}`"
  ></button>
</template>

<style scoped>
.hint-trigger {
  padding: .25rem;
  border: 0;
  color: #0d6efd;
  background: transparent;
  line-height: 1;
}
</style>
